import { render, staticRenderFns } from "./NewCollectionCentre.vue?vue&type=template&id=6c2928c3"
import script from "./NewCollectionCentre.vue?vue&type=script&lang=js"
export * from "./NewCollectionCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports